<template>
  <RevCard
    class="h-full"
    :class="
      isProductCompared ? 'border-action-default-hi' : 'border-transparent'
    "
    data-qa="productCard"
    :hoverable="true"
  >
    <ProductCardContent
      :comparison="{
        isComparisonEnabled,
        isComparisonAddProductDisabled,
        isResponsiveComparisonEnabled,
        comparisonProducts,
      }"
      :options="{
        withAddToCart: addToCartListener,
        list,
        position,
        withStartingFrom,
        extendedDescription,
      }"
      :product="{
        ...product,
        listingId: listingId,
        rawProduct: product.product,
      }"
      :tags
      @add-to-cart="
        ({ status }) => {
          emit('add-to-cart', { status })
        }
      "
      @link-click="emit('link-click', $event)"
      @toggle-comparison-product="emit('toggle-comparison-product', listingId)"
    />
  </RevCard>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance } from 'vue'

import type { Grade, LinkInternal, Price } from '@backmarket/http-api'
import type { Deal } from '@backmarket/nuxt-layer-cms/products/algolia/types'
import { RevCard } from '@ds/components/Card'

import type {
  ComparisonProduct,
  Granularity,
  Product,
  Tag,
} from '../../models/product'

import ProductCardContent from './ProductCardContent.vue'

export interface ProductCardProps {
  description?: string
  discountedPrice?: Price
  imageSrc: string
  listingId: string
  price: Price
  priceNew?: Price
  reviewRating?: {
    count: number
    average: number
  }
  title: string
  url: string | LinkInternal
  grade?: Grade
  warranty?: number
  withStartingFrom?: boolean
  specifications?: Array<{
    label: string
    values: string[]
  }>
  colorSwatches?: Array<{ name: string; value?: string }>
  isComparisonEnabled?: boolean
  comparisonProducts?: ComparisonProduct[]
  isComparisonAddProductDisabled?: boolean
  isResponsiveComparisonEnabled?: boolean
  product: Product
  list?: string
  position?: number
  deal?: Deal
  extendedDescription?: boolean
  tags?: Tag[]
  granularity?: Granularity
  specialOfferType?: number
}

const {
  listingId,
  comparisonProducts,
  isComparisonAddProductDisabled = false,
  isResponsiveComparisonEnabled = false,
  extendedDescription = false,
  ...product
} = defineProps<ProductCardProps>()

const emit = defineEmits([
  'add-to-cart',
  'toggle-comparison-product',
  'link-click',
])

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart

const isProductCompared = computed(() => {
  return comparisonProducts?.some((p) => p.listingId === listingId) || false
})
</script>
